import React from 'react'
import { Form } from 'formik'
import { FormRow, TitleBar } from 'components/Shared/CrudComponents'
import { useTranslation } from 'react-i18next'
import { createValidationSchema } from './form'
import { FormikForm } from 'components/Shared/FormikForm'
import styles from './CustomFieldsForm.module.css'
import TranslationsForm from 'components/CustomFields/CustomFieldsForm/TranslationsForm'
import { ControlledSelectField } from 'components/Shared/ControlledSelectField'
import customFieldModules from 'constants/customFieldModules'
import FieldDetails from 'components/CustomFields/CustomFieldsForm/FieldDetails'
import FieldTypeSelectField from 'components/CustomFields/CustomFieldsForm/FieldTypeSelectField'
import LabeledCheckboxField from 'components/Shared/LabeledCheckboxField/LabeledCheckboxField'
import SectionSelectForm from 'components/CustomFields/CustomFieldsForm/SectionSelectForm'
import { mapToArray } from 'constants/utils'

export default function CustomFieldsForm ({ initialValues, onSubmit, title, isEditForm }) {
  const { t } = useTranslation()

  return (
    <>
      <FormikForm
        initialValues={initialValues}
        validationSchema={createValidationSchema()}
        validateOnChange={false}
        validateOnBlur
        enableReinitialize
        onSubmit={onSubmit}>
        {({ setFieldValue, values }) => (
          <Form>
            <TitleBar
              buttonLabel={t('customField.form.submit')}
              title={title}
              buttonDisabled={!values.module || !values.section || !values.type}/>
            <div className="p-4">
              <FormRow>
                <FormColumn>
                  <RowHeader index={1}
                             label={'customField.form.headers.selectModule'}/>
                </FormColumn>
                <FormColumn>
                  <FormColumnContent>
                    <ControlledSelectField
                      fieldName={'module'}
                      label={t('form.search')}
                      options={mapToArray(customFieldModules)}
                      getOptionValue={module => module.value}
                      getOptionLabel={module => t(module.label)}
                      onChange={() => setFieldValue('section', undefined)}
                      disabled={isEditForm}
                    />
                  </FormColumnContent>
                </FormColumn>
              </FormRow>
              <FormRow>
                <FormColumn>
                  <RowHeader index={2}
                             label={'customField.form.headers.selectSection'}/>
                </FormColumn>
                <FormColumn>
                  <FormColumnContent>
                    <SectionSelectForm
                      fieldName={'section'}
                      label={'form.search'}/>
                  </FormColumnContent>
                </FormColumn>
              </FormRow>
              <FormRow>
                <FormColumn>
                  <RowHeader index={3}
                             label={'customField.form.headers.defineField'}/>
                  <FormColumnContent>
                    <FieldTypeSelectField disabled={isEditForm}/>
                    <TranslationsForm label={'customField.form.translations'}
                                      fieldName={'translations'}/>
                    <LabeledCheckboxField fieldName={'isEnabled'}
                                          label={'customField.form.isEnabled'}/>
                    <LabeledCheckboxField fieldName={'isRequired'}
                                          label={'customField.form.isRequired'}/>
                    <LabeledCheckboxField fieldName={'isVisibleOnPrint'}
                                          label={'customField.form.isVisibleOnPrint'}/>
                  </FormColumnContent>
                </FormColumn>
                <FormColumn>
                  <FormColumnContent>
                    <FieldDetails/>
                  </FormColumnContent>
                </FormColumn>
              </FormRow>
            </div>
          </Form>
        )}
      </FormikForm>
    </>
  )
}

function RowHeader ({ index, label }) {
  const { t } = useTranslation()

  return <div className={styles.labelContainer}>
    <div className={styles.labelIndex}>{index}</div>
    <div className={styles.label}>{t(label)}</div>
  </div>
}

function FormColumn ({ children }) {
  return <div className={styles.formColumn}>
    {children}
  </div>
}

function FormColumnContent ({ children }) {
  return <div className={styles.formColumnContent}>
    {children}
  </div>
}
